/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useContext, useEffect, useState, useCallback } from 'react';
import Pagination from '../../../components/Pagination';
import 'tw-elements';
import { useLocation, useSearchParams } from 'react-router-dom';
import ItemShimmer from '../../../components/Shimmer/itemShimmer';
import SearchEmptyScreen from '../../../components/SearchEmptyScreen';
import { useDispatch, useSelector } from 'react-redux';
import ConfirmationPrompt from '../../../components/ConfirmationPrompt';
import AnimatedModel from '../../../components/Animation/AnimatedModel';
import { dataService } from '../../../services/data.services';
import GlobalContext from '../../../components/Context/GloablContext';
import Table from './components/Table';
import TopBarWithShadow from '../../../components/TopBar/TopBarWithShadow';
import EmptyScreenBranch from '../../ManageBranches/components/EmptyScreen';
import CardHeader from '../../../components/CardHeader';
import { Feeterm } from './FeeTermSlice';
import EmptyAddScreen from '../../../components/EmptyAddScreen';
import Debounce from '../../../CommonMethods/Debounce';
import { GetBranchId } from '../../../CommonMethods/GetBranchId';

const FeeTerm = () => {
    const { isSideNavBar, setToastErrorMessage, setToastmessage,toastErrorMessage } = useContext(GlobalContext);
    const dispatch = useDispatch();
    const FeeTermList = useSelector(state => state.FeeTermSlice);
    const { List } = FeeTermList
    const [loading, setLoading] = useState(true);
    const [loadingActivation, setLoadingActivation] = useState(false);
    const [addOpen, setAddOpen] = useState(false)
    const location = useLocation();
    const [confirmationState, setConfirmationState] = useState({});
    const [sideModelType, setSideModelType] = useState('');
    const [searchParams, setSearchParams] = useSearchParams({page_number: 1});
    const [email, setemail] = useState('');
    const [fistLoading, setFirstLoading] = useState(false)
    const [editValue, setEditValue] = useState({})
    const [searchFieldDebounce, setsearchFieldDebounce] = useState(searchParams.get('search') === null ? '' : decodeURIComponent(searchParams.get('search')));
    const initialInputValue = {
        admin_first_name : '',
        admin_last_name: '',
        admin_email_address: '',
        admin_mobile_number:'',
        roles:[]
    }
    const [emptyScreenMessage, setEmptyScreenMessage] = useState('');
    const [inputValue, setInputValue] = useState(initialInputValue);
    /**
     * The function sets the loading state to true and updates the search parameters with a page number
     * of 1.
     */
    const handleLoadData = () => {
        setLoading(true);
        setSearchParams({ page_number:  1 })
    }
    /* `const getBranch` is a function that is defined using the `useCallback` hook. It is used
    to fetch the list of admin users from the server and update the state with the response data.
    The function uses the `dispatch` function from the `useDispatch` hook to dispatch an action
    creator called `AdminUser` with the `searchParams` as an argument. The `AdminUser` action
    creator is responsible for making an API call to fetch the list of admin users from the server.
    Once the API call is successful, the function checks if the `success_status` property of the
    response data is true. If it is true, the function does nothing. If it is false, the function
    sets an error message using the `setToastErrorMessage` function. The `getBranch` function
    is memoized using the `useCallback` hook with the `location` value as a dependency, which means
    that it will only be redefined if the `location` value changes. */
    const getInstitutionUsers = useCallback(async () => {
        try {
            setLoading(true)
            dispatch(Feeterm(searchParams)).then((response) => {
                if (response?.payload?.data.status===200) {

                    if(Math.ceil(response?.payload?.data?.data.total_count / 10) <  Number(searchParams.get('page_number'))) {
                        if(response?.payload?.data?.data.total_count !== 0) {
                            // setToastErrorMessage('Something went wrong. Please try again')
                            setEmptyScreenMessage("No data found");
                        } else {
                            setEmptyScreenMessage("No matching records found.")
                        }
                        setLoading(false);
                    } else {
                        setLoading(false);
                    }
                } else {
                    setLoading(false);
                    setEmptyScreenMessage("No data found.");
                    // setToastErrorMessage('Something went wrong. Please try again')
                }
            })
            if(email===''){
                setemail(localStorage.getItem('email'))
            }
            setsearchFieldDebounce(!searchParams.get('search') ? '' : decodeURIComponent(searchParams.get('search')) || '')
        } catch (error) {
            handleLoadData()
            console.error(error);
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
        }
    }, [location]);

    
    /**
     * This function handles the click event of a page number and updates the search parameters with
     * the selected page number.
     */
    const handleOnClickPageNumber = (pageNum) => {
        setLoading(true);
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
    }

    /**
     * This function updates search parameters with a new key-value pair and sets the page number to 1.
     */
    const handleSearchParams = (key, value) => {
        // setLoading(true);
        // setEmptyScreenMessage("We couldn't find anything that matched your search")
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        if(key === 'search') {params[key] = encodeURIComponent(value);}
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params})
    }

    const optimizedFn = useCallback(
        Debounce((key, value) => handleSearchParams(key,value)),
        [searchParams]
    );

    /* `useEffect(() => { getInstitutionUsers(); }, [getInstitutionUsers]);` is a hook that is used to run
    the `getInstitutionUsers` function whenever the `getInstitutionUsers` function changes. In this case,
    the `getInstitutionUsers` function is memoized using the `useCallback` hook, which means that it
    will only be redefined if the `location` value changes. Therefore, the `useEffect` hook will run
    the `getInstitutionUsers` function whenever the `location` value changes. This hook is used to
    fetch the list of admin users from the server and update the `tableData` state with the response
    data. */
    useEffect(() => {
        // if(!searchParams.get('sort')) {
        //     handleSearchParams('sort', `created_at+desc`)
        // }
        getInstitutionUsers();
    }, [searchParams]);

    /**
     * This function handles the click event for a side popup by resetting an input value and toggling
     * the state of a boolean variable.
     */
    const handleSidePopupClick = (type, item) => {
        if(type === 'Edit') {
            setInputValue({
                admin_first_name : item.first_name,
                admin_last_name: item.last_name,
                admin_email_address: item.email_address,
                admin_mobile_number: item.mobile_number,
                roles: item.roles
            })
            setEditValue(item)
        } else {
            setInputValue(initialInputValue)
        }
        setSideModelType(type)
        setAddOpen(!addOpen);
    }

    /**
     * The function sets the confirmation state to an empty object when a confirmation click event
     * occurs.
     */
    const handleConformationClick = () => {
        setConfirmationState({});
    }

    const InstitutionData = JSON.parse(localStorage.getItem('institutionData'));

    /**
     * This function handles the activation of a user account and updates the user list accordingly.
     */
    const handleOnCLickActivate = async(e) => {
        setLoadingActivation(true);
        const branch_id = await GetBranchId()
        try {
            let body = {
                "status": confirmationState.status === 'Activate' ? true : false,
                // branch_id:branch_id             
            }
            let endpoint= `feeterms/${confirmationState?.item?._id}`
            
            const response = await dataService.PatchAPI(body,endpoint);
            getInstitutionUsers()
            const state=confirmationState.status==='Deactivate'?'deactivated':'activated'
            setLoadingActivation(false);
            setToastmessage(`Fee term ${state} successfully`);
            handleConformationClick();
        } catch (error) {
            console.log('error', error)
            handleConformationClick();
            setLoadingActivation(false);
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
        }
    }
    return (
        <>
            <CardHeader noPadding>
                <TopBarWithShadow
                    AddButton={true}
                    SearchInput={true}
                    Tittle={'Fee Terms'}
                    AddButtonName={'Add Fee Term'}
                    SearchValue={searchFieldDebounce}
                    handleOnClickSearch={setsearchFieldDebounce}
                    optimizedFn={optimizedFn}                    
                    handleSidePopupClick={handleSidePopupClick}
                    customSearchPlaceHolder={`Fee Term Name`}
                    isClick='/fee-management/fee-terms/create-fee-term'
                    
                />
                <CardHeader body >
                    {loading ? (
                        <ItemShimmer />
                    ) : (
                        <>
                            <Table
                                handleSidePopupClick={handleSidePopupClick}
                                pageNumber={Number(searchParams.get('page_number')) || 1}
                                handleOnClickSort={handleSearchParams}
                                sortValue={searchParams.get('sort') || ''}
                                setConfirmationState={setConfirmationState}
                                email={email}
                                setLoading={setLoading}
                                showHeaders={true}
                                searchParams={searchParams}
                            />
                            {(
                                List.total_count > 10 && (
                                    <Pagination
                                        TotalCount={List.total_count}
                                        totalPageNumber={Math.ceil(List.total_count / 10)}
                                        selectedPageNumber={Number(searchParams.get('page_number')) || 1}
                                        handleOnClickPageNumber={handleOnClickPageNumber}
                                    />
                                )
                            )}
                        </>
                    )
                    }</CardHeader>
            </CardHeader>
            {Object.keys(confirmationState)?.length > 0 && confirmationState?.status  && 
            <AnimatedModel 
                Children={
                    <ConfirmationPrompt 
                        handleOnCLickActivate={handleOnCLickActivate}
                        handleClose={handleConformationClick}
                        tittle= {`${confirmationState.status==='Reset Password'?'Reset Password':`${confirmationState.status} Fee Term`} `}
                        message = {`Are you sure you want to ${confirmationState.status} the Fee Term '${confirmationState?.item?.fee_term_name}' ?`}
                        buttonName = {confirmationState.status === 'Reset Password' ? "Reset" : confirmationState.status}
                        loadingActivation={loadingActivation}
                    />
                }
            />  
            }
        </>
    );
}

export default FeeTerm;
